import React from "react";
import DateUtility from "./lib/dateUtility";
import { ReactRenderer } from "./lib/ReactRenderer";
/**
 * The head of the front page: "Hej Søren" and when the next shift is. The name is the one the
 * memberinfo script put on the page; the shift comes from the schedule of the member.
 */
export default class HomeGreetingComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isLoaded: false, next: null };
    }
    componentDidMount() {
        fetch(`/bpapi/shiftschedule/memberschedule`, { method: "GET" })
            .then((response) => response.ok ? response.json() : Promise.reject(response.status))
            .then((result) => { var _a, _b; return this.setState({ isLoaded: true, next: (_b = (_a = result.shifts) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null }); })
            .catch(() => this.setState({ isLoaded: true }));
    }
    render() {
        var _a, _b, _c;
        const fullName = (_c = (_b = (_a = window.currentMember) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : "";
        const firstName = fullName.trim().split(/\s+/)[0];
        let subtitle = "";
        if (this.state.isLoaded) {
            const when = this.state.next ? DateUtility.whenPhrase(DateUtility.parse(this.state.next.dtStart)) : "";
            subtitle = this.state.next
                ? `Din næste vagt er ${when}.`
                : "Du har ingen kommende vagter.";
        }
        return (React.createElement("div", { className: "bi-greeting" },
            React.createElement("h1", null, firstName ? `Hej ${firstName}` : "Hej"),
            subtitle ? React.createElement("p", null, subtitle) : null));
    }
}
ReactRenderer.render("homegreetingcomponent", (elem) => React.createElement(HomeGreetingComponent, Object.assign({}, elem.dataset)));
